<div class="page-head">
    <h2>Маркетплейс</h2>
    <div class="view-buttons"
         role="group"
    >
        <button data-action="tableView"
                (click)="viewMode = 'table'"
                [class.selected]="viewMode === 'table'"
        >
            <i class="ri-list-check-2"></i>
        </button>
        <button data-action="gridView"
                (click)="viewMode = 'grid'"
                [class.selected]="viewMode === 'grid'"
        >
            <i class="ri-layout-grid-line"></i>
        </button>
    </div>
</div>

<div class="page-container">
    <div class="categories-container">
        <div class="categories-list">
            <div class="categories-list-header">
                <span><i class="ri-book-marked-fill"></i> Каталог</span>

                <button data-action="createMainCategory"
                        class="category-button"
                        (click)="modalService.openTemplateModal(createCategoryModal)"
                >
                    <i class="ri-add-circle-fill"></i>
                </button>
            </div>

            @if (categories) {
                @for (mainCategory of categories; track mainCategory.category.cuid) {
                    <div class="main-category"
                         [class.selected]="path.includes(mainCategory.category.cuid)"
                         (click)="changePath(mainCategory, 0)"
                    >
                        {{ mainCategory.category.title }}
                    </div>
                    @if (mainCategory.children.length && path.includes(mainCategory.category.cuid)) {
                        <div>
                            @for (subCategory of mainCategory.children; track subCategory.category.cuid; let isLast = $last) {
                                <div class="sub-category"
                                     [class.last]="isLast"
                                >
                                    <div class="sub-body"
                                         [class.selected]="path.includes(subCategory.category.cuid)"
                                         (click)="changePath(subCategory, 1)"
                                    >
                                        <span>
                                            {{ subCategory.category.title }}
                                        </span>
                                        @if (subCategory.children.length) {
                                            @if (path.includes(subCategory.category.cuid)) {
                                                <i class="ri-arrow-down-s-line"></i>
                                            } @else {
                                                <i class="ri-arrow-up-s-line"></i>
                                            }
                                        }
                                    </div>
                                    @if (subCategory.children.length && path.includes(subCategory.category.cuid)) {
                                        <div>
                                            @for (thirdPartyCategory of subCategory.children; track thirdPartyCategory.category.cuid) {
                                                <div class="third-party-category"
                                                     [class.selected]="path.includes(thirdPartyCategory.category.cuid)"
                                                     (click)="changePath(thirdPartyCategory, 2)"
                                                >
                                                    {{ thirdPartyCategory.category.title }}
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                }
            }
        </div>
    </div>

    <div class="cards-container">
        <div class="head-container">
            <div class="search-input">
                <i class="ri-search-line"></i>
                <input type="text"
                       id="search"
                       placeholder="Название или артикул">
            </div>
            <div>
                <button class="button light-button"
                        (click)="cardType = 'SERVICE'; modalService.openTemplateModal(createCardModal)">
                    <i class="ri-add-circle-fill"></i> Услуга
                </button>
                <button class="button light-button"
                        (click)="cardType = 'PRODUCT'; modalService.openTemplateModal(createCardModal)">
                    <i class="ri-add-circle-fill"></i> Товар
                </button>
            </div>
        </div>
        @if (viewMode === 'grid') {
            <div class="cards-grid">
                @for (card of cards; track card.puid) {
                    <div class="product-card"
                         (click)="router.navigate(['account/production/cards', card.puid])"
                    >
                        <h2>{{ card.product_card.title }}</h2>
                        <div class="image-container">
                            @if (card.photo_first) {
                                <img [src]="card.photo_first.originImage"
                                     alt="#"
                                >
                            } @else {
                                <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                                     alt="#"
                                     height="170"
                                     width="230"
                                >
                            }
                        </div>
                        <section class="info-section">
                            <div class="dot-type {{ card.product_card.card_type.toLowerCase() }}"></div>
                            <span class="type-color">{{ card.product_card.card_type.toLowerCase() }}</span>
                            <span class="public-cards-counter"><i class="ri-profile-fill"></i> 12 карточек</span>
                        </section>
                        <div [innerHTML]="card.product_card.description ?? 'Описания нет'"
                             class="description"
                        ></div>
                    </div>
                }
            </div>
        } @else {
            <div class="cards-table">
                <section class="members_table">
                    <table mat-table
                           [dataSource]="cards"
                    >
                        <!-- photo_first Column -->
                        <ng-container matColumnDef="photo_first">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [width]="140"
                            >
                                Фото
                            </th>
                            <td mat-cell
                                *matCellDef="let element"
                                [width]="100"
                            >
                                <div class="image-container mini">
                                    @if (element.photo_first) {
                                        <img [src]="element.photo_first.originImage"
                                             alt="#"
                                        >
                                    } @else {
                                        <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                                             alt="#"
                                             height="170"
                                             width="230"
                                        >
                                    }
                                </div>
                            </td>
                        </ng-container>

                        <!-- title Column -->
                        <ng-container matColumnDef="title">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [width]="300"
                            >
                                Наименование
                            </th>
                            <td mat-cell
                                *matCellDef="let element"
                            >
                                        <span style="cursor: pointer;"
                                              (click)="router.navigate(['account/production/cards', element.puid])"
                                        >
                                            {{ element.product_card.title }}
                                        </span>
                            </td>
                        </ng-container>

                        <!-- description Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell
                                *matHeaderCellDef
                            >
                                Описание
                            </th>
                            <td mat-cell
                                *matCellDef="let element"
                            >
                                <div class="description"
                                     [innerHTML]="element.product_card.description ?? '-'"
                                ></div>
                            </td>
                        </ng-container>

                        <!-- type Column -->
                        <ng-container matColumnDef="card_type">
                            <th mat-header-cell
                                *matHeaderCellDef
                                [width]="100"
                            >
                                Тип
                            </th>
                            <td mat-cell
                                *matCellDef="let element"
                            >
                                <div style="display: flex;">
                                    <div class="dot-type {{ element.product_card.card_type.toLowerCase() }}"></div>
                                    <span class="type-color">{{ element.product_card.card_type.toLowerCase() }}</span>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row
                            *matHeaderRowDef="['photo_first', 'title', 'description', 'card_type'], sticky: true"
                        ></tr>
                        <tr mat-row
                            *matRowDef="let row; columns: ['photo_first', 'title', 'description', 'card_type'];"
                        ></tr>
                        <tr class="mat-row"
                            *matNoDataRow
                        >
                            <td class="mat-sell"
                                colspan="4"
                            >
                                <strong>{{ 'EMPTY_LISTS.EMPTY' | translate }}</strong>
                            </td>
                        </tr>
                    </table>
                </section>
            </div>
        }
    </div>
</div>

<ng-template #createCardModal
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>Создать карточку</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input class="form-control"
               name="cardName"
               required
               #cardName
        >
        <button class="btn btn-success"
                (click)="createProductCard(cardName.value, modal);"
        >
            <span>Создать</span>
        </button>
    </div>
</ng-template>

<ng-template #createCategoryModal
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>Создать категорию</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input class="form-control"
               name="categoryName"
               required
               #categoryName
        >
        <button class="btn btn-success"
                (click)="createCategory(categoryName.value, modal);"
                data-action="createFolderButton"
        >
            <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>
